import { Component, OnDestroy, OnInit, OnChanges, SimpleChanges, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormBuilder, Validators, ControlContainer, FormGroupDirective, FormControl, FormGroup, UntypedFormControl } from '@angular/forms';
import { interval, Subscription, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, startWith, tap, delay, takeUntil, map, switchMap, catchError, finalize } from 'rxjs/operators';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { ActivatedRoute, Router } from '@angular/router';
import { OrdersService } from '../../services/orders.service';
import { GlobalsService } from '../../services/globals.service';
import { CarrierTrackingService } from '../../services/carrier-tracking.service';
import { UsersService } from '../../services/users.service';
import { CustomerService } from '../../services/customer.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { normalizeSalesmanAllowed } from '../../classes/default-salesman-allowed';
import { orderMatchesSalespeopleFilter } from '../../utils/order-salesperson-filter';
import { PurchasingService } from '../../services/purchasing.service';
import { OmsService } from '../../services/oms.service';
import { ReportsService } from '../../services/reports.service';
import { Directive, HostListener } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Subject, Observable } from 'rxjs';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import * as FileSaver from 'file-saver';
import { Location } from '@angular/common'

import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { orderChannelSourceLabel } from '../../utils/order-channel-source';
import * as moment from 'moment';
import { PrintService } from 'app/services/print.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { HttpResponse } from '@angular/common/http';

declare const google: any;

const OPEN_ORDERS_HEADER_COLUMNS_STAFF = [
	'orderno',
	'statusname',
	'pickprinted',
	'datecreated',
	'deliverto',
	'ponumber',
	'haspo',
	'shipvia',
	'notes',
	'comments',
	'takenby',
	'total',
	'void',
];

const OPEN_ORDERS_HEADER_COLUMNS_SALESMAN = [
	'orderno',
	'statusname',
	'pickprinted',
	'datecreated',
	'deliverto',
	'ponumber',
	'shipvia',
	'notes',
	'comments',
	'takenby',
	'total',
];

const STAFF_EDITS_ALLOWED = {
	discounts: true,
	editar: true,
	editbilling: true,
	editshipping: true,
	editcontact: true,
	editprofile: true,
	editnotes: true,
	takepayment: true,
	cancelorder: true,
};

@Component({
	selector: 'app-open-orders',
	templateUrl: './open-orders.component.html',
	styleUrls: ['./open-orders.component.scss'],
})
export class OpenOrdersComponent implements OnInit, OnChanges, OnDestroy {

	CHAT_ROOM = 'OrderBoard';

	@ViewChild('purchaseOrderDetails') purchaseOrderDetailsRef: ElementRef;
	@ViewChild('orderStatusView') orderStatusViewRef: ElementRef;
	@ViewChild('popTemplate') popTemplateRef: ElementRef;
	@ViewChild('confirmCancelPoRef') confirmCancelPoRef: ElementRef;
	@ViewChild('confirmCancel') confirmCancel: ElementRef;
	@ViewChild('pickPdfModal') pickPdfModalRef: ElementRef;

	pendingCancelOrderNo: any;
	purchaseOrderLinked: any;


	@ViewChild('mapDiv') mapDivEle: ElementRef;
	@ViewChild('posRecRef') posRecRef: ElementRef;
	@ViewChild('itemSearchFilterInput') itemSearchFilterInputRef: ElementRef<HTMLInputElement>;
	@ViewChild('orderSearchFilterInput') orderSearchFilterInputRef: ElementRef<HTMLInputElement>;
	@ViewChild('openOrdersTableScroll') openOrdersTableScrollRef: ElementRef<HTMLElement>;

	@Input() customerdata: any = false;
	@Input() item: any = false;
	@Input() orderstatus: any = false;
	@Input() flipfilter: any = false;
	@Output() cart_updated = new EventEmitter < string > ();
	@Output() cancel = new EventEmitter < boolean > ();
	@Output() orderloaded = new EventEmitter < any > ();
	@Output() preorderloaded = new EventEmitter < any > ();
	@Output() orderinvoice = new EventEmitter < any > ();
	@Output() reloadCustomer = new EventEmitter < any > ();

	snoozeForm: UntypedFormGroup;

	searchInput = new UntypedFormControl('');
	statusSearch = new UntypedFormControl('');
	order_status_edit = new UntypedFormControl('');
	searchInputItems = new UntypedFormControl('');
	defaultlocation = new UntypedFormControl('');
	shipvia = new UntypedFormControl('');
	podetails: any = false;
	openorders: any = [];
	customertrans: any = [];
	filteredItems: any = [];
	map: any = false;
	updated_map: any = false;
	markers: any = [false];
	pathlines: any = false;
	isMerging = false;
	selectedPrinted: any = '';
	map_animation: any = google.maps.Animation.DROP;
	fetch_subscribtion: any = false;
	headercolumns: string[] = [...OPEN_ORDERS_HEADER_COLUMNS_STAFF];

	rechtml: any = false;
	thistran: any = false;

	pickDrawerOpened = false;
	pickDrawerOrderNo: string | null = null;
	pickDrawerLoading = false;
	pickSafeUrl: SafeResourceUrl | null = null;
	private pickObjectUrl: string | null = null;

	pickPdfOrderNo: string | null = null;
	pickPdfLoading = false;
	pickPdfBase64: string | null = null;
	private pickPdfFetchSub: Subscription | null = null;

	orderupdates: any = [];
	openOrderData: any = [];
	allopenOrderData: any = [];
	config: any = [];
	pickinglink = '';
	invoicelink = '';
	orderdetails: any = [];
	locations: any = [];
	ispos = '';

	itemsearchresults: any = [];
	itemsearch = false;
	order_statuses: any = false;
	user: any = false;
	ref_location: any = false;
	private matSortRef: MatSort;
	private paginatorRef: MatPaginator;

	@ViewChild(MatSort)
	set matSort(sort: MatSort) {
		this.matSortRef = sort;
		this.wireOpenOrdersSortAndPaginator();
	}

	@ViewChild(MatPaginator)
	set matPaginator(paginator: MatPaginator) {
		this.paginatorRef = paginator;
		this.wireOpenOrdersSortAndPaginator();
	}

	snoozeorder;
	snoozetime;
	loading = false;
	cancellingOrderNo: string | null = null;
	dataSubscription: any = Subscription;

	selectedOrderSource = '';
	private searchDebounce: any;
	numberofdays = 1;
	issnoozed = false
	initaldate = new Date();
	shipvias: any = [];
	salespeople: any = [];
	salespersonRef = new UntypedFormControl([]);
	/** Distinct `takenby` userids present in the loaded orders. */
	orderUsers: any = [];
	takenbyRef = new UntypedFormControl([]);
	issalesman: any = false;
	isPosUser: any = false;
	editsallowed: any = { ...STAFF_EDITS_ALLOWED };

	orderSources = [
		{ value: '1', viewValue: 'Backoffice' },
		{ value: '2', viewValue: 'POS' },
		{ value: '3', viewValue: 'Salesman' },
		{ value: '4', viewValue: 'Online' },
	];

	printedcount = 0;
	notprintedcount = 0;
	totalcount = 0;
	newInputData = false;
	subscriptionActive = false;
	totalsArray: { title: string;value: number } [] = [];
	askForCancelReason = false;

	private defaultReasons = [
		{ id: '1', label: 'Customer Request', code: 'CUSTOMER_REQUEST', requires_notes: '0', sort_order: '1', is_active: '1' },
		{ id: '2', label: 'Out of Stock', code: 'OUT_OF_STOCK', requires_notes: '0', sort_order: '2', is_active: '1' },
		{ id: '3', label: 'Duplicate Order', code: 'DUPLICATE_ORDER', requires_notes: '0', sort_order: '3', is_active: '1' },
		{ id: '4', label: 'Pricing Error', code: 'PRICING_ERROR', requires_notes: '1', sort_order: '4', is_active: '1' },
		{ id: '5', label: 'Fraud Concern', code: 'FRAUD', requires_notes: '1', sort_order: '5', is_active: '1' },
		{ id: '6', label: 'Shipping Delay', code: 'SHIPPING_DELAY', requires_notes: '1', sort_order: '6', is_active: '1' },
		{ id: '7', label: 'Other', code: 'OTHER', requires_notes: '1', sort_order: '99', is_active: '1' }
	];

	predefinedReasons: any = [];

	showReasonError = false;
	cancelReason: any = '';
	cancelNotes: any = '';

	pendingCancelReason = '';
	pendingCancelNotes = '';
	pendingCancelTimestamp = '';
	pendingCancelPayload: any = [];
	exportingOrders = false;

	userid_link: any = false;

	private openOrdersTableScrollAnchor = 0;

	private currentFilters = {
		searchTerm: '',
		itemSearchTerm: '',
		selectedStatuses: [],
		selectedShipVia: [],
		selectedSalespeople: [],
		selectedTakenby: [],
		selectedOrderSource: '',
		selectedPrinted: '' as any,
		warehouse: ''
	};

	// Unified filtering method that combines all filters
	applyAllFilters(): void {
		let filteredData = [...this.allopenOrderData];

		// Apply search filter
		if (this.currentFilters.searchTerm) {
			const beforeCount = filteredData.length;
			filteredData = this.globalSearchService.filterItemO(
				filteredData,
				this.currentFilters.searchTerm.trim(),
				'orderno,transno,ponumber,debtorno,deliverto,deliverydate,notes'
			);
			
		}

		// Apply item search filter
		if (this.currentFilters.itemSearchTerm) {
			const beforeCount = filteredData.length;
			const searchdata = filteredData.map((item: any) => item.details);
			const searchresults = this.globalSearchService.filterItem(
				searchdata, 
				this.currentFilters.itemSearchTerm, 
				'orderno,narrative,stkcode,description,ordervalue'
			);
			const mapped = searchresults.map((i: any) => i.orderno);
			filteredData = filteredData.filter((o: any) => mapped.includes(o.orderno));
			
		}

		// Apply status filter
		if (this.currentFilters.selectedStatuses.length > 0 && !this.currentFilters.selectedStatuses.includes('')) {
			const beforeCount = filteredData.length;
			filteredData = filteredData.filter(order =>
				this.currentFilters.selectedStatuses.includes(order.orderstatusid)
			);
			
		}

		// Apply ship via filter
		if (this.currentFilters.selectedShipVia.length > 0) {
			const beforeCount = filteredData.length;
			filteredData = filteredData.filter(item => 
				this.currentFilters.selectedShipVia.includes(item.shipvia)
			);
		}

		// Apply salesperson filter (dropdown is salesmancode; takenby is userid)
		if (
			this.currentFilters.selectedSalespeople.length > 0 &&
			!this.currentFilters.selectedSalespeople.includes('')
		) {
			filteredData = filteredData.filter((order) =>
				orderMatchesSalespeopleFilter(order, this.currentFilters.selectedSalespeople, this.salespeople)
			);
		}

		// Apply user filter (matches the order's takenby userid directly, unlike the
		// salespeople filter above which resolves salesmancode)
		if (
			this.currentFilters.selectedTakenby.length > 0 &&
			!this.currentFilters.selectedTakenby.includes('')
		) {
			filteredData = filteredData.filter((order) =>
				this.currentFilters.selectedTakenby.includes(String(order?.takenby ?? ''))
			);
		}

		// Apply order source filter
		if (this.currentFilters.selectedOrderSource) {
			const want = String(this.currentFilters.selectedOrderSource);
			filteredData = filteredData.filter(order =>
				String(order?.details?.placedfrom ?? '') === want
			);
		}

		// Apply printed filter
		if (this.currentFilters.selectedPrinted !== '') {
			const beforeCount = filteredData.length;
			filteredData = filteredData.filter(order => {
				if (this.currentFilters.selectedPrinted === true) {
					return order.details.printedpackingslip === '1';
				} else if (this.currentFilters.selectedPrinted === false) {
					return order.details.printedpackingslip === '0';
				}
				return true;
			});
		}

		const scrollHost = this.openOrdersTableScrollRef?.nativeElement;
		const scrollTop = scrollHost?.scrollTop ?? 0;

		this.openOrderData = filteredData;
		if (this.openorders instanceof MatTableDataSource) {
			this.openorders.data = filteredData;
		} else {
			this.openorders = new MatTableDataSource(filteredData);
			this.configureOpenOrdersDataSource(this.openorders);
		}
		this.wireOpenOrdersSortAndPaginator();

		if (scrollHost) {
			requestAnimationFrame(() => {
				scrollHost.scrollTop = scrollTop;
			});
		}

		if (this.user?.user?.department === '3' && filteredData.length === 1) {
			this.invoiceOrder(filteredData[0].orderno);
		}
	}

	private openOrderShipToSortKey(row: any): string {
		const detailsName = row.details?.deliverto != null && String(row.details.deliverto).trim() !== ''
			? String(row.details.deliverto)
			: '';
		const topName = row.deliverto != null ? String(row.deliverto) : '';
		const primary = (detailsName || topName).trim();
		const shiptoPlain = row.shipto != null
			? String(row.shipto).replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()
			: '';
		return `${primary} ${shiptoPlain}`.trim().toLowerCase();
	}

	private configureOpenOrdersDataSource(ds: MatTableDataSource<any>): void {
		ds.sortingDataAccessor = (row: any, column: string) => {
			switch (column) {
				case 'deliverto':
					return this.openOrderShipToSortKey(row);
				case 'total': {
					const isTires = this.config?.env?.package === 'tires';
					const n = isTires
						? Number(row.total)
						: (row.usetotal == 1 ? Number(row.total) : Number(row.subtotal));
					return Number.isFinite(n) ? n : 0;
				}
				case 'datecreated': {
					const d = row.date_created;
					if (d == null || d === '') {
						return 0;
					}
					const t = new Date(d).getTime();
					return Number.isFinite(t) ? t : 0;
				}
				case 'pickprinted':
					return Number(row.printedpackingslip) || 0;
				default:
					return row[column];
			}
		};
	}

	private wireOpenOrdersSortAndPaginator(): void {
		if (!(this.openorders instanceof MatTableDataSource)) {
			return;
		}
		if (this.matSortRef) {
			this.openorders.sort = this.matSortRef;
		}
		if (this.paginatorRef) {
			this.openorders.paginator = this.paginatorRef;
		}
	}

	constructor(private printService: PrintService, private usersService: UsersService, private omsService: OmsService, private formBuilder: UntypedFormBuilder, public purchasingService: PurchasingService, public ordersService: OrdersService, public globalSearchService: GlobalSearchService, public router: Router, public customerService: CustomerService, private location: Location, private globalsService: GlobalsService, private modalService: NgbModal, private reportsService: ReportsService, private cdr: ChangeDetectorRef, private carrierTracking: CarrierTrackingService, private sanitizer: DomSanitizer) {

		this.config = this.globalsService.getApiConfig();

		if (this.config.ordercancelreason) {
			this.askForCancelReason = true;
		}

		this.subscriptions.push(
			this.usersService.isPosUser().pipe(takeUntil(this.destroy$)).subscribe((isPOS) => {
				if (isPOS) {
					this.isPosUser = true;
				}
			})
		);



		this.subscriptions.push(
			this.ordersService.getCancelReasons().pipe(takeUntil(this.destroy$)).subscribe((r: any) => {
				if (r && r.success && r.data && Array.isArray(r.data) && r.data.length > 0) {
					this.predefinedReasons = r.data;
				} else {
					this.predefinedReasons = this.defaultReasons;
				}
			}, () => {
				this.predefinedReasons = this.defaultReasons;
			})
		);

		if (this.isPosUser) {
			this.pickinglink = this.config.apiServer.baseUrl + this.config.apiServer.pickingLink
			this.ispos = 'isPOS=true'
		}
		else {
			this.pickinglink = this.config.apiServer.baseUrl + this.config.apiServer.pickingLink
			this.ispos = 'isPOS=false'
		}
		this.invoicelink = this.config.apiServer.baseUrl + this.config.apiServer.pickingInvoice;

		this.subscriptions.push(
			this.globalSearchService.shipvia.pipe(takeUntil(this.destroy$)).subscribe(r => {
				if (!r) {
					this.subscriptions.push(
						this.globalsService.getShipVia().pipe(takeUntil(this.destroy$)).subscribe((results: any) => {
							this.globalSearchService.shipvia.next(results)
							this.shipvias = results;
						})
					);
				} else {
					this.shipvias = r;
				}
			})
		);

		this.subscriptions.push(
			this.reportsService.getSalesPeople().pipe(takeUntil(this.destroy$)).subscribe((results: any) => {
				this.salespeople = results;
			})
		);

		this.subscriptions.push(
			this.globalSearchService.user.pipe(takeUntil(this.destroy$)).subscribe(results => {
			//only run if user is definied
				if (this.user) {
					if (results.user.defaultlocation.loccode != this.ref_location) {
						this.defaultlocation.setValue(this.user.user.defaultlocation.loccode);
						this.loadData();
						this.ref_location = false;
					}
				}

				this.user = results
				this.userid_link = '&userid=' + this.user.user.userid;

				if (!this.ref_location) {
					this.ref_location = this.user.user.defaultlocation.loccode;
				}


				if (this.user.user.issalesman) {
					this.editsallowed = normalizeSalesmanAllowed(this.config?.salesmanAllowed);
					this.issalesman = true;
					this.headercolumns = [...OPEN_ORDERS_HEADER_COLUMNS_SALESMAN];
					this.clearOrderStatusEditMode();
				} else {
					this.issalesman = false;
					this.editsallowed = { ...STAFF_EDITS_ALLOWED };
					this.headercolumns = [...OPEN_ORDERS_HEADER_COLUMNS_STAFF];
				}

			})
		);
	}

	ngOnInit(): void {

		this.subscriptions.push(
			this.globalSearchService.locations.pipe(takeUntil(this.destroy$)).subscribe(async (results: any) => {
				this.locations = results;
				if (results) {

					this.defaultlocation.setValue(this.user.user.defaultlocation.loccode)
					this.subscriptions.push(
						this.ordersService.getOrderStatuses().pipe(takeUntil(this.destroy$)).subscribe(r => {
							this.order_statuses = r;

							// Check if there's no existing order status value
							if (!this.orderstatus) {
							// Filter out the order status with ID 51 for aaprod client
								if (!this.config.liveinventory && !this.customerdata?.customer?.debtorno) {
									let filteredStatuses;
									if (this.config.env.client != 'aaprod') {
									// For non-aaprod clients, don't apply any status filter
										filteredStatuses = [];
									} else {
									// For aaprod client, exclude status 51
										filteredStatuses = this.order_statuses
											.filter(status => status.order_status_id !== '51')
											.map(status => status.order_status_id);
									}

									// Only set filters if we have filtered statuses
									if (filteredStatuses.length > 0) {
										this.statusSearch.setValue(filteredStatuses);
										this.currentFilters.selectedStatuses = filteredStatuses;
									}
								}

								// Load data
								this.loadData();
							}
						})
					);

				}
			})
		);
		this.snoozeForm = this.formBuilder.group({
			message: ['', Validators.required],
			initials: ['', Validators.required],
			//numberofdays: [1],
			//datepicked: [''],
			// ['', Validators.required],
		});

		this.subscriptions.push(
			this.searchInput.valueChanges.pipe(
				debounceTime(650),
				takeUntil(this.destroy$)
			).subscribe(value => {
				this.onInput(value);
			})
		);


	}

	usePrintConnect() {
		const ep = this.usersService.usePrintConnect();
		this.user.usePrintConnect = ep;
		return ep;
	}

	printCustomerCopy(orderid) {
		this.ordersService.printCustomerCopy(orderid).subscribe((res: any) => {
			const type = 'INVOICE';
			const user = this.user.user.userid;
			const printers = this.usersService.getDevicesByType(user, type);
			if (printers && printers.length && res.base64.length) {
				this.omsService.setNewOrder();
				const customer_copy = res['base64'][1];
				const data = { pdf: customer_copy, user: user, devices: printers }
				this.omsService.sendPrintCommand({ data, roomName: 'Printers' }, cb => {
					this.omsService.setPrintedOrder();
				})
			}

		})
	}

	canEmailCustomerCopy(): boolean {
		const c = this.config?.env?.client;
		return c === 'km' || c === 'moov' || c === 'moov_sandbox';
	}

	/**
	 * Staff may always cancel. Salesmen are gated on `salesmanAllowed.cancelorder`
	 * in the client config (src/assets/config/config.<client>.json), which defaults
	 * to false. KM stays enabled regardless for backwards compatibility with the
	 * behaviour that predated the config flag.
	 */
	canCancelOrder(): boolean {
		if (!this.issalesman) {
			return true;
		}
		if (this.config?.env?.client === 'km') {
			return true;
		}
		return !!this.editsallowed?.cancelorder;
	}

	emailCustomerCopy(tran: any) {
		if (!this.canEmailCustomerCopy()) {
			return;
		}
		const suggestedEmail = (tran?.invoiceemailaddress || tran?.email || '').toString();
		const email = window.prompt('Email customer copy to:', suggestedEmail);
		if (!email || !email.trim()) {
			return;
		}
		this.ordersService.emailCustomerCopy(tran.orderno, email.trim()).subscribe(() => {
			window.alert('Customer copy email queued.');
		}, () => {
			window.alert('Unable to send customer copy email.');
		});
	}

	filterWarehouse(input: any) {
		this.currentFilters.warehouse = input;
		this.loadData();
	}

	noNewLines(input: any) {
		if (input) {
			return input.replace(/[^\x20-\x7E]/gmi, ' ').trim().replace(/\\n/g, ' ');
		}

		return input;
	}

	getShipVia(idin: any): string {
		if (!this.shipvias || !Array.isArray(this.shipvias)) {
			return 'N/A';
		}

		const filtered = this.shipvias.filter((r: any) => {
			return r.shipper_id === idin;
		})[0];

		return filtered ? filtered.shippername : 'N/A';
	}


	openPickDrawer(orderno: string | number, printPick = false, event?: Event): void {
		event?.preventDefault();
		event?.stopPropagation();
		if (printPick) {
			this.openPickPrintDrawer(orderno);
			return;
		}
		this.openPickPdfModal(String(orderno));
	}

	private openPickPrintDrawer(orderno: string | number): void {
		this.pickDrawerOrderNo = String(orderno);
		this.revokePickPreviewBlob();
		this.pickSafeUrl = null;
		this.pickDrawerLoading = true;
		this.pickDrawerOpened = true;

		const url = `${this.pickinglink}${orderno}&${this.ispos}&print=true`;

		const sub = this.ordersService.getDocumentBlob(url).pipe(
			takeUntil(this.destroy$),
			finalize(() => {
				this.pickDrawerLoading = false;
				this.cdr.markForCheck();
			})
		).subscribe({
			next: (res: HttpResponse<Blob>) => {
				const ct = (res.headers.get('content-type') || '').toLowerCase();
				const blob = res.body;
				if (!blob || blob.size < 1 || ct.includes('application/json') || ct.includes('text/json')) {
					this.openPickDocumentFallbackTab(url);
					return;
				}
				this.pickObjectUrl = URL.createObjectURL(blob);
				this.pickSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.pickObjectUrl);
				// Also send the pick to the assigned PICK printer via Print Connect (keeps the preview).
				this.sendPickToPrinter(blob);
				this.ordersService.markPickPrinted(orderno).pipe(takeUntil(this.destroy$)).subscribe();
			},
			error: () => {
				this.openPickDocumentFallbackTab(url);
			},
		});
		this.subscriptions.push(sub);
	}

	// Send a picking ticket to the user's PICK-assigned printer through Print Connect.
	// Mirrors the invoice/receipt send pattern (getDevicesByType -> sendPrintCommand -> printPdf).
	private sendPickToPrinter(blob: Blob): void {
		try {
			const user = this.user?.user?.userid;
			if (!user || !blob) {
				return;
			}
			const printers = this.usersService.getDevicesByType(user, 'PICK');
			if (!printers || !printers.length) {
				// No PICK device assigned for this user — preview only.
				return;
			}
			const reader = new FileReader();
			reader.onloadend = () => {
				const result = typeof reader.result === 'string' ? reader.result : '';
				const base64 = result.includes(',') ? result.split(',')[1] : result;
				if (!base64) {
					return;
				}
				this.omsService.setNewOrder();
				const data = { pdf: base64, user: user, devices: printers };
				this.omsService.sendPrintCommand({ data, roomName: 'Printers' }, cb => {
					this.omsService.setPrintedOrder();
				});
			};
			reader.readAsDataURL(blob);
		} catch (e) {
			console.error('Failed to send pick to printer:', e);
		}
	}

	private openPickPdfModal(orderno: string): void {
		this.pickPdfFetchSub?.unsubscribe();
		this.pickPdfOrderNo = orderno;
		this.pickPdfBase64 = null;
		this.pickPdfLoading = true;

		const url = `${this.pickinglink}${orderno}&${this.ispos}`;
		const modalAlive = { v: true };

		const modalRef = this.modalService.open(this.pickPdfModalRef, {
			ariaLabelledBy: 'pick-pdf-modal-title',
			size: 'xl',
			scrollable: true,
		});

		const modalClosed$ = new Subject<void>();
		modalRef.result.finally(() => {
			modalAlive.v = false;
			if (!modalClosed$.closed) {
				modalClosed$.next();
				modalClosed$.complete();
			}
			this.pickPdfFetchSub?.unsubscribe();
			this.pickPdfFetchSub = null;
			this.pickPdfBase64 = null;
			this.pickPdfLoading = false;
			this.pickPdfOrderNo = null;
			this.cdr.markForCheck();
		});

		this.pickPdfFetchSub = this.ordersService.getDocumentBlob(url).pipe(
			takeUntil(this.destroy$),
			takeUntil(modalClosed$)
		).subscribe({
			next: (res: HttpResponse<Blob>) => {
				const ct = (res.headers.get('content-type') || '').toLowerCase();
				const blob = res.body;
				if (!blob || blob.size < 1 || ct.includes('application/json') || ct.includes('text/json')) {
					modalRef.dismiss();
					this.openPickDocumentFallbackTab(url);
					return;
				}
				this.blobToBase64(blob).then(
					(b64) => {
						if (!modalAlive.v) {
							return;
						}
						this.pickPdfBase64 = b64;
						this.pickPdfLoading = false;
						this.cdr.markForCheck();
					},
					() => {
						modalRef.dismiss();
						this.openPickDocumentFallbackTab(url);
					},
				);
			},
			error: () => {
				modalRef.dismiss();
				this.openPickDocumentFallbackTab(url);
			},
		});
	}

	private blobToBase64(blob: Blob): Promise<string> {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.onloadend = () => {
				const dataUrl = reader.result as string;
				if (!dataUrl || typeof dataUrl !== 'string' || !dataUrl.includes(',')) {
					reject(new Error('Invalid pick document'));
					return;
				}
				resolve(dataUrl.split(',')[1]);
			};
			reader.onerror = () => reject(reader.error ?? new Error('read failed'));
			reader.readAsDataURL(blob);
		});
	}

	get pickPdfDownloadFilename(): string {
		return this.pickPdfOrderNo ? `pick-slip-${this.pickPdfOrderNo}.pdf` : 'pick-slip.pdf';
	}

	private openPickDocumentFallbackTab(url: string): void {
		this.revokePickPreviewBlob();
		this.pickSafeUrl = null;
		this.pickDrawerOpened = false;
		this.pickDrawerLoading = false;
		window.open(url, '_blank', 'noopener,noreferrer');
		this.globalSearchService.showNotification('Pick document opened in a new tab (preview unavailable in-panel).', 'info', 'bottom', 'right');
	}

	private revokePickPreviewBlob(): void {
		if (this.pickObjectUrl) {
			URL.revokeObjectURL(this.pickObjectUrl);
			this.pickObjectUrl = null;
		}
	}

	closePickDrawer(): void {
		this.pickDrawerOpened = false;
	}

	onPickDrawerOpenedChange(open: boolean): void {
		if (!open) {
			this.revokePickPreviewBlob();
			this.pickSafeUrl = null;
			this.pickDrawerOrderNo = null;
			this.pickDrawerLoading = false;
		}
	}

	printPacking(orderno: any) {
		this.thistran = { orderno: orderno }; // Store just the order number

		this.ordersService.getOrderPackingList(orderno).subscribe((result: any) => {
			this.rechtml = result.display;

			this.modalService.open(this.posRecRef, { ariaLabelledBy: 'modal-title', size: 'zip' }).result.then((result) => {}, (reason) => {
				this.rechtml = false;
				this.thistran = false;
				this.omsService.setPrintedOrder();
			});
		});

	}


	sendPrint() {

		this.omsService.setNewOrder();
		this.subscriptions.push(
			this.ordersService.getOrderPackingList(this.thistran.orderno).pipe(
				switchMap((result: any) => {
					return this.globalSearchService.user.pipe(
						map(user => ({ result, user }))
					);
				}),
				takeUntil(this.destroy$)
			).subscribe(({ result, user }) => {
				const printers = this.usersService.getDevicesByType(user.user.userid, 'RECEIPT');

				const data = { pdf: result.print, user: user, devices: printers }
				if (printers && printers.length) {

					this.omsService.sendPrintCommand({ data, roomName: 'Printers' }, cb => {
						this.omsService.setPrintedOrder();
					})
				}
			})
		);

	}

	setSnoozeOrder(orderno) {
		this.snoozeorder = orderno;

		const orderdata = this.allopenOrderData.filter(r => {
			return r.orderno = orderno;
		})[0];

		this.issnoozed = (orderdata.snoozed == '1') ? true : false;
		this.modalService.open(this.popTemplateRef, { ariaLabelledBy: 'modal-title', size: 'xl', animation: false }).result.then((result) => {
			this.snoozeorder = false;
		}, (reason) => {

		});
	}

	setSnooze(event: any) {
		this.numberofdays = parseInt(event.target.value);
		this.dateNumberChanged();
	}

	dateNumberChanged() {

		const subject = new Date();
		subject.setDate(subject.getDate());

		const until = new Date();
		until.setDate(until.getDate() + this.numberofdays);

		this.initaldate = new Date(until);
	}

	dateChanged(event) {
		const now = new Date();
		now.setDate(now.getDate());
		const until = new Date(event.value);
		until.setDate(until.getDate());

		const difference = (until.getTime() - now.getTime())
		const days = difference / (1000 * 60 * 60 * 24);
		this.numberofdays = Math.ceil(days);
		this.initaldate = new Date(event.value)
	}

	removeSnooze(orderno: any) {
		const orderdata = this.allopenOrderData.filter(r => {
			return r.orderno = orderno;
		})[0];

		const data = {
			orderno: orderno,
			days: this.numberofdays,
			inititals: this.snoozeForm.controls['initials'].value,
			reason: this.snoozeForm.controls['message'].value,
			user: this.user.user
		};


		this.omsService.sendSnoozeRemove({ data, roomName: this.CHAT_ROOM }, cb => {});

		this.snoozeForm = this.formBuilder.group({
			message: ['', Validators.required],
			initials: ['', Validators.required],
		});

		setTimeout(() => {
			this.loadData();
		}, 500);

	}

	voidPreAuth(orderno: any) {

		const payload = {
			orderno: orderno
		}

		this.ordersService.voidPreAuth(payload).subscribe((r: any) => {
			if (r && r.success) {
				if (r.message?.description) {
					this.globalSearchService.showNotification(r.message?.description, 'success', 'bottom', 'right');
				}
			} else {
				if (r.message?.description) {
					this.globalSearchService.showNotification(r.message?.description, 'danger', 'bottom', 'right');
				}
			}
		})
	}

	snooze(orderno: any) {

		const orderdata = this.allopenOrderData.filter(r => {
			return r.orderno = orderno;
		})[0];

		// if(this.snoozeForm.status == "INVALID" && orderdata.snoozed != '1') {
		// 	return false;
		// }

		const data = {
			orderno: orderno,
			days: this.numberofdays,
			inititals: this.snoozeForm.controls['initials'].value,
			reason: this.snoozeForm.controls['message'].value,
			user: this.user.user
		};


		this.omsService.sendSnoozeUpdate({ data, roomName: this.CHAT_ROOM }, cb => {

		});

		this.snoozeForm = this.formBuilder.group({
			message: ['', Validators.required],
			initials: ['', Validators.required],
			//numberofdays: [1],
			//datepicked: [''],
			// ['', Validators.required],
		});


		setTimeout(() => {
			this.loadData();
		}, 500);

		this.snoozeorder = false;
		this.issnoozed = false;
		this.modalService.dismissAll();
	}

	saveStatusUpdate(tran: any) {
		if (this.issalesman) {
			return;
		}
		let removepo = false;
		const type = this.order_status_edit.value;

		if(tran.orderstatusid == 85 && type != 85){
			removepo = true;
		}

		const data = {
			trans: tran,
			type: type,
			user: this.user,
			removepo: removepo
		}

		this.ordersService.updateOrderStatus(data).subscribe((r: any) => {
			if (r.success) {
				const scrollHost = this.openOrdersTableScrollRef?.nativeElement;
				const y = scrollHost?.scrollTop ?? 0;
				tran.edit = false;
				const status = this.order_statuses.filter(s => {
					return s.order_status_id === data.type;
				})[0];
				tran.statusname = status.name;
				tran.orderstatusid = data.type;
				this.order_status_edit.reset();

				this.omsService.sendOrderCheckUpdate({ data, roomName: this.CHAT_ROOM }, cb => {});

				if (scrollHost) {
					requestAnimationFrame(() => {
						scrollHost.scrollTop = y;
						requestAnimationFrame(() => {
							scrollHost.scrollTop = y;
						});
					});
				}
			}
		})
	}

	viewStatus(tran: any) {
		this.ordersService.getOrderStatusView(tran.orderno).subscribe((order: any) => {
			this.orderdetails = order

			this.modalService.open(this.orderStatusViewRef, { ariaLabelledBy: 'modal-title', size: 'xl', animation: false }).result.then((result) => {

			}, (reason) => {

			});

			setTimeout(() => {
				if (this.orderdetails.dispatch_details.nextlast) {
					this.drawMap();
				}
			}, 500);
		});
	}

	openModal(content) {
		this.modalService.open(content, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {}, (reason) => {});
	}

	viewPurchaseOrder(orderno: any) {
		this.purchasingService.getPurchaseOrder(orderno).subscribe((order: any) => {
			this.podetails = order
			this.modalService.open(this.purchaseOrderDetailsRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

			}, (reason) => {

			});
		});
	}

	search() {
		this.currentFilters.searchTerm = this.searchInput.value || '';
		this.applyAllFilters();
		this.globalSearchService.blurInputElement(this.orderSearchFilterInputRef);
	}

	private clearOrderStatusEditMode(): void {
		const rows = this.openorders instanceof MatTableDataSource ? this.openorders.data : (this.openorders || []);
		if (Array.isArray(rows)) {
			rows.forEach((ord: any) => {
				ord.edit = false;
			});
		}
		this.order_status_edit.reset();
	}

	toggleEdit(tran: any) {
		if (this.issalesman) {
			return;
		}
		if (!tran.edit) {
			const rows = this.openorders instanceof MatTableDataSource ? this.openorders.data : [];
			rows.forEach((ord: any) => {
				if (ord !== tran) {
					ord.edit = false;
				}
			});
			tran.edit = true;
			this.order_status_edit.setValue(tran.orderstatusid);
		} else {
			tran.edit = false;
		}
	}

	onOrderStatusSelectPanelChange(opened: boolean): void {
		const el = this.openOrdersTableScrollRef?.nativeElement;
		if (!el) {
			return;
		}
		if (opened) {
			this.openOrdersTableScrollAnchor = el.scrollTop;
		} else {
			const y = this.openOrdersTableScrollAnchor;
			requestAnimationFrame(() => {
				el.scrollTop = y;
				requestAnimationFrame(() => {
					el.scrollTop = y;
				});
			});
		}
	}

	buildHtmlAndExport(doctype) {
		this.exportingOrders = true;
		let html;
		html = '<table style="width: 100%"><thead><tr style="background: black; color: white">';
		html += '<th style="text-align:left">Tran Date</th>';
		html += '<th style="text-align:left">Customer</th>';
		html += '<th style="text-align:left">PO</th>';
		html += '<th style="text-align:center">Orderno</th>';
		html += '<th style="text-align:center">Status</th>';
		html += '<th style="text-align:center">Shipvia</th>';
		html += '<th style="text-align:left">Items</th>';
		html += '<th style="text-align:left">Track#</th>';
		html += '</tr></thead><tbody>';
		this.openorders.data.forEach(ord => {
			// Safely handle tracking
			const tracks = ord.tracking && ord.tracking.length ? ord.tracking.map((o: any) => { return o.trackingnumber }).join(', ') : '';
			
			// Safely handle order lines with fallback to details
			let lines = '';
			if (ord.lines && Array.isArray(ord.lines) && ord.lines.length > 0) {
				// Use ord.lines if available
				lines = ord.lines.map((o: any) => { 
					const qty = o.quantity || o.qty || '1';
					const itemCode = o.stockid || o.stkcode || 'Unknown';
					return qty + 'x ' + itemCode + ', ' +'\n'; 
				}).join('').slice(0, -2);
			} else if (ord.details) {
				// Fallback to ord.details if ord.lines is not available
				const detail = ord.details;
				const qty = detail.quantity || detail.qty || detail.ordered || '1';
				const itemCode = detail.stockid || detail.stkcode || 'Unknown';
				lines = qty + 'x ' + itemCode + '\n';
			}
			
			// Safely handle shipvia
			const shipvia = this.shipvias.find((via: any) => via.shipper_id === ord.shipvia)?.['shippername'] ?? 'N/A';
			
			html += '<tr>';
			html += `<td style='text-align: left;'>${ord.trandate || ''}</td>`;
			html += `<td style='text-align: left;'>${ord.debtorno}.${ord.branchcode}</td>`;
			html += `<td style='text-align: left;'>${ord.ponumber || ''}</td>`;
			html += `<td style='text-align: center;'>${ord.orderno}</td>`;
			html += `<td style='text-align: center;'>${ord.status || ''}</td>`;
			html += `<td style='text-align: center;'>${shipvia}</td>`;
			html += `<td style='text-align: left;'>${lines}</td>`;
			html += `<td style='text-align: left;'>${tracks}</td>`;
			html += '</tr>';
		});
		html += '</tbody></table>';
		doctype === 'pdf' ? this.exportPdf(html) : this.exportXls(html);
	}

	exportPdf(html) {
		const today = new Date().toLocaleString();
		const customer = this.customerdata.customer ?? false;
		const encoded: string = this.globalSearchService.base64encode(html);
		const data = {
			content: encoded,
			filename: `Open Orders Export - ${today}`,
			title: (customer ? `${customer.debtorno}.${customer.branchcode} ${customer.brname} - ` : '') + 'Open Orders Export',
			subtitle: 'Created ' + today.toLocaleString()
		}
		this.printService.pdf(data).subscribe((result: any) => {
			this.globalSearchService.downloadPdf(result.content, data.filename);
			this.exportingOrders = false;
		});
	}

	exportXls(html) {
		const today = new Date().toLocaleString();
		const customer = this.customerdata.customer ?? false;
		const encoded: string = this.globalSearchService.base64encode(html);
		const data = {
			content: encoded,
			filename: `Open Orders Export - ${today}`,
			title: (customer ? `${customer.debtorno}.${customer.branchcode} ${customer.brname} - ` : '') + 'Open Orders Export',
			subtitle: 'Created ' + today.toLocaleString()
		}
		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
			this.exportingOrders = false;
		});
	}

	filterShipVia() {
		this.currentFilters.selectedShipVia = this.shipvia.value || [];
		this.applyAllFilters();
	}

	filterItems() {
		this.currentFilters.selectedStatuses = this.statusSearch.value || [];
		this.applyAllFilters();
	}

	filterPrinted() {
		this.currentFilters.selectedPrinted = this.selectedPrinted;
		this.applyAllFilters();
	}

	filterItemSource() {
		this.currentFilters.selectedOrderSource = this.selectedOrderSource;
		this.applyAllFilters();
	}

	channelSourceLabel(tran: any): string | null {
		return orderChannelSourceLabel(tran);
	}

	filterSalesperson(trigger = true) {
		const raw = this.salespersonRef.value;
		this.currentFilters.selectedSalespeople = Array.isArray(raw)
			? raw
			: raw != null && raw !== ''
				? [raw]
				: [];
		this.applyAllFilters();
	}

	filterTakenby(trigger = true) {
		const raw = this.takenbyRef.value;
		this.currentFilters.selectedTakenby = Array.isArray(raw)
			? raw
			: raw != null && raw !== ''
				? [raw]
				: [];
		this.applyAllFilters();
	}

	/**
	 * Build the user dropdown from the loaded orders rather than a lookup, so it
	 * only ever offers users who actually have orders on the board.
	 */
	private buildOrderUsers(orders: any[]) {
		const seen = new Set<string>();
		orders.forEach((o) => {
			const u = String(o?.takenby ?? '').trim();
			if (u !== '') {
				seen.add(u);
			}
		});
		this.orderUsers = Array.from(seen).sort();
	}

	searchItems(clicked:any = false) {
		this.currentFilters.itemSearchTerm = this.searchInputItems.value || '';
		this.applyAllFilters();
		if(clicked){
			setTimeout(()=>{
				this.globalSearchService.blurInputElement(this.itemSearchFilterInputRef);
			}, 800)
		}
	}

	onKeydown(event: KeyboardEvent) {
		if (event.key === 'Enter') {
			clearTimeout(this.searchDebounce);
			this.onInput(this.searchInput.value);
		}
	}

	private debounceTimeout: any;
	private destroy$ = new Subject<void>();
	private subscriptions: Subscription[] = [];
	onInput(event: any): void {
		clearTimeout(this.debounceTimeout);

		const inputTerm = this.searchInput.value.trim();
		const debounceDelay = 300;

		this.debounceTimeout = setTimeout(() => {
			this.currentFilters.searchTerm = inputTerm;
			this.applyAllFilters();
		}, debounceDelay);
	}

	private resetTableData(): void {
		this.currentFilters = {
			searchTerm: '',
			itemSearchTerm: '',
			selectedStatuses: [],
			selectedShipVia: [],
			selectedSalespeople: [],
			selectedTakenby: [],
			selectedOrderSource: '',
			selectedPrinted: '' as any,
			warehouse: ''
		};
		this.applyAllFilters();
	}

	// Public method to clear all filters
	clearAllFilters(): void {
		// Reset all form controls
		this.searchInput.setValue('');
		this.searchInputItems.setValue('');
		this.statusSearch.setValue([]);
		this.shipvia.setValue([]);
		this.salespersonRef.setValue([]);
		this.takenbyRef.setValue([]);
		this.selectedOrderSource = '';
		this.selectedPrinted = '';
		
		// Reset current filters state
		this.resetTableData();
	}

	// Get the count of active filters
	getActiveFiltersCount(): number {
		let count = 0;
		
		if (this.currentFilters.searchTerm) {count++;}
		if (this.currentFilters.itemSearchTerm) {count++;}
		if (this.currentFilters.selectedStatuses.length > 0) {count++;}
		if (this.currentFilters.selectedShipVia.length > 0) {count++;}
		if (this.currentFilters.selectedSalespeople.length > 0) {count++;}
		if (this.currentFilters.selectedTakenby.length > 0) {count++;}
		if (this.currentFilters.selectedOrderSource) {count++;}
		if (this.currentFilters.selectedPrinted !== '') {count++;}
		
		return count;
	}

	// Check if any filters are active
	hasActiveFilters(): boolean {
		return this.getActiveFiltersCount() > 0;
	}

	// Get a summary of active filters
	getActiveFiltersSummary(): string[] {
		const summary: string[] = [];
		
		if (this.currentFilters.searchTerm) {
			summary.push(`Search: "${this.currentFilters.searchTerm}"`);
		}
		if (this.currentFilters.itemSearchTerm) {
			summary.push(`Item Search: "${this.currentFilters.itemSearchTerm}"`);
		}
		if (this.currentFilters.selectedStatuses.length > 0) {
			const statusNames = this.order_statuses
				?.filter(status => this.currentFilters.selectedStatuses.includes(status.order_status_id))
				.map(status => status.name) || [];
			summary.push(`Status: ${statusNames.join(', ')}`);
		}
		if (this.currentFilters.selectedShipVia.length > 0) {
			const shipViaNames = this.shipvias
				?.filter(ship => this.currentFilters.selectedShipVia.includes(ship.shipper_id))
				.map(ship => ship.shippername) || [];
			summary.push(`Ship Via: ${shipViaNames.join(', ')}`);
		}
		if (this.currentFilters.selectedSalespeople.length > 0) {
			const salespersonNames = this.salespeople
				?.filter(sp => this.currentFilters.selectedSalespeople.includes(sp.salesmancode))
				.map(sp => sp.salesmanname) || [];
			summary.push(`Salespeople: ${salespersonNames.join(', ')}`);
		}
		if (this.currentFilters.selectedOrderSource) {
			const sourceName = this.orderSources.find(s => s.value === this.currentFilters.selectedOrderSource)?.viewValue || '';
			summary.push(`Source: ${sourceName}`);
		}
		if (this.currentFilters.selectedPrinted !== '') {
			const printedText = this.currentFilters.selectedPrinted === true ? 'Yes' : 'No';
			summary.push(`Printed: ${printedText}`);
		}
		
		return summary;
	}

	private performSearch(term: string) {
		this.currentFilters.searchTerm = term.trim();
		this.applyAllFilters();
	}

	transformTotals(
		totals: Record < string, number > ,
		savedTotals: any
	): any[] {
		try {
			// Check if savedTotals is an array
			if (!Array.isArray(savedTotals)) {}

			// Map totals object into a key-value structure
			const totalsMap = new Map(Object.entries(totals));

			// Update saved_totals based on matching codes
			return savedTotals.map(entry => {
				const matchingKey = this.mapCodeToKey(entry.code); // Map code to corresponding totals key
				const newValue = matchingKey ? totalsMap.get(matchingKey) : undefined;

				if (newValue !== undefined) {
					return {
						...entry,
						text: newValue.toFixed(2), // Update with new value, formatted to two decimals
					};
				}
				return entry; // Return unchanged if no match
			});
		} catch (error) {

			// Return original savedTotals if an error occurs
			return Array.isArray(savedTotals) ? savedTotals : [];
		}
	}

	// Helper function to map codes to totals keys
	private mapCodeToKey(code: string): string | undefined {
		const codeKeyMap: Record < string, string > = {
			sub_total: 'subtotal',
			total: 'total',
			fees: 'fees',
			freight: 'freight',
			tax: 'tax',
			fet: 'fet',
		};
		return codeKeyMap[code] || undefined;
	}

	viewCustomer(debtorno: string) {
		if (!this.isPosUser) {
			this.router.navigate(['/customers/view/' + debtorno]);
		}
	}

	viewInvoicedOrder(orderno: any, content: any) {
		this.ordersService.getInvoicedOrder(orderno).subscribe((order: any) => {
			this.orderdetails = order


			this.modalService.open(content, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

			}, (reason) => {});

			//wait for element to appear
			if (order && order.dispatch_details.status_id === '29') {
				setTimeout(() => {
					this.drawMap();
				}, 500);
			}

		});
	}

	viewOrder(orderno: any, content: any): void {
		this.ordersService.getOrder(orderno).subscribe({
			next: (order: any) => {
				this.orderdetails = order;

				// Update saved_totals with transformed totals
				if (order.totals && order.saved_totals) {
					this.orderdetails.saved_totals = this.transformTotals(order.totals, order.saved_totals);
				}

				// Open the modal
				this.modalService
					.open(content, { ariaLabelledBy: 'modal-title', size: 'xl' })
					.result.then(
						() => {},
						() => {
							this.totalsArray = [];
						}
					);

				// Wait for element to appear and draw the map
				if (order?.dispatch_details?.status_id === '29') {
					setTimeout(() => this.drawMap(), 500);
				}
			},
			error: (err) => {
				console.error('Error fetching order details:', err);
			},
		});
	}

	invoiceOrder(orderno: any) {
		this.ordersService.loadSalesOrder(orderno).subscribe((result: any) => {})
		this.orderinvoice.emit(orderno);
	}

	loadOrder(tran: any) {
		const orderno = tran.orderno;
		//preorder
		switch (tran.orderstatusid) {
		case '3':
			this.ordersService.loadPreOrder(orderno, this.customerdata.customer).subscribe((result: any) => {
				this.orderinvoice.emit(false);
				this.preorderloaded.emit(result);
			});
			break;
		default:
			this.ordersService.loadSalesOrder(orderno).subscribe((result: any) => {
				this.orderinvoice.emit(false);
				this.orderloaded.emit(result);
			});
			break;
		}
	}

	showOrderPaymentAttachedIndicator(tran: any): boolean {
		if (!tran || tran.invoiced) {
			return false;
		}
		if (!tran.has_payment_attached) {
			return false;
		}
		const sid = String(tran.orderstatusid ?? '');
		return sid !== '52' && sid !== '53';
	}

	loadData(silent = false, onComplete?: () => void) {
		if (!silent) {
			if (this.newInputData) {
				if (this.subscriptionActive) {
					this.dataSubscription.unsubscribe();
				}
				this.loading = false;
			} else if (this.loading) {
				return;
			}
			this.loading = true;
		}
		this.subscriptionActive = true;

		const search = this.customerdata?.customer?.debtorno || this.customerdata?.debtorno || '';
		const hasCustomerContext = !!search;
		const locSuffix = this.defaultlocation.value
			? `&loccode=${encodeURIComponent(this.defaultlocation.value)}`
			: '';
		let searchObs$;
		if (this.item) {
			searchObs$ = this.ordersService.getItemOrderSearch({ item: this.item, loccode: this.defaultlocation.value });
		} else if (!this.flipfilter) {
			searchObs$ = this.ordersService.getCustomerOpenOrders(search + locSuffix);
		} else {
			searchObs$ = this.ordersService.getCustomerOpenOrdersFiltered({ orders: this.flipfilter });
		}

		this.dataSubscription = searchObs$.pipe(
			debounceTime(300),
			switchMap(results => {
				this.handleSearchResults(results);
				return of(results);
			}),
			catchError(error => {
				return this.handleError(error);
			}),
			takeUntil(this.destroy$),
			finalize(() => {
				this.subscriptionActive = false;
				if (!silent) {
					this.loading = false;
				}
				onComplete?.();
			})
		).subscribe(() => {});
	}

	private handleSearchResults(results: any) {
		// Handle results - ensure we always have an array (even if empty)
		const orderResults = Array.isArray(results) ? results : [];
		
		this.openOrderData = orderResults;
		this.allopenOrderData = orderResults;
		this.buildOrderUsers(orderResults);

		// Apply all current filters to the newly loaded data
		this.applyAllFilters();

		// Return the results so that switchMap can continue
		return orderResults;
	}

	private handleError(error: any) {
		// Optionally, show a notification to the user about the error
		this.globalSearchService.showNotification('Failed to load data.', 'danger', 'bottom', 'right');
		// Stop any loading indicators
		this.loading = false;
		// Return a fallback value (like `null` or `[]`) to prevent further processing
		return [];
	}

	ngOnChanges(changes: any) {
		if (changes.flipfilter) {
			this.newInputData = true;
			this.loadData();
		}
	}


	cancelOrder(orderno: any) {
		if (this.askForCancelReason) {
			this.pendingCancelOrderNo = orderno;
			this.modalService.open(this.confirmCancel, {
				ariaLabelledBy: 'modal-title',
				size: 'md',
			});
		} else {
			this.pendingCancelOrderNo = orderno;
			this.cancelReason = 'None Given'
			this.handleConfirmCancelOrderOnly([]);
		}
	}

	onReasonChange(): void {
		if (this.cancelReason !== 'Other') {
			this.cancelNotes = '';
		}
	}

	get reasonRequiresNote(): boolean {
		return this.cancelReason?.requires_notes === '1';
	}

	selectReason(reason: any) {
		this.cancelReason = reason;
		this.showReasonError = false;
	}

	handleConfirmCancelOrderOnly(modal: any) {
		if (!this.cancelReason || (this.cancelReason === 'Other' && !this.cancelNotes.trim())) {
			this.showReasonError = true;
			return;
		}

		this.showReasonError = false;

		// Build base payload
		const payload: any = {
			orderno: this.pendingCancelOrderNo,
			reason: this.cancelReason,
			notes: this.cancelNotes.trim(),
			timestamp: new Date().toISOString()
		};

		this.cancellingOrderNo = payload.orderno;
		if (this.askForCancelReason) {
			modal.close();
		}

		this.ordersService.cancelOrder(payload).subscribe({
			next: (result: any) => {
				if (!result.success && result.requires_confirmation) {
					this.pendingCancelOrderNo = payload.orderno;
					this.purchaseOrderLinked = result.purchase_orderno;
					this.pendingCancelPayload = { ...payload, cancelPo: true };
					if (this.askForCancelReason) {
						this.modalService.open(this.confirmCancelPoRef, {
							ariaLabelledBy: 'modal-title',
							size: 'md'
						}).result.catch(() => {
							this.cancellingOrderNo = null;
							this.cdr.detectChanges();
						});
					}
					return;
				}
				if (!result.success) {
					this.cancellingOrderNo = null;
					this.cdr.detectChanges();
					const msg = result.message || result.error || 'Failed to cancel order.';
					this.globalSearchService.showNotification(msg, 'danger', 'bottom', 'right');
					return;
				}
				this.handleCancelResponse(result, this.pendingCancelOrderNo);
			},
			error: () => {
				this.cancellingOrderNo = null;
				this.cdr.detectChanges();
				this.globalSearchService.showNotification('Failed to cancel order.', 'danger', 'bottom', 'right');
			}
		});
	}

	confirmCancelPo(forceCancelPo: boolean, modal: any) {
		const orderno = this.pendingCancelOrderNo;
		const force = forceCancelPo ? 'yes' : 'no';

		this.pendingCancelPayload.cancelPo = forceCancelPo;
		const payload = this.pendingCancelPayload;
		modal.close();

		this.ordersService.cancelOrderWithPo(payload, force).subscribe({
			next: (results: any) => {
				if (!results.success) {
					this.cancellingOrderNo = null;
					this.cdr.detectChanges();
					const msg = results.message || results.error || 'Failed to cancel order.';
					this.globalSearchService.showNotification(msg, 'danger', 'bottom', 'right');
					return;
				}
				this.handleCancelResponse(results, orderno);
			},
			error: () => {
				this.cancellingOrderNo = null;
				this.cdr.detectChanges();
				this.globalSearchService.showNotification('Failed to cancel order.', 'danger', 'bottom', 'right');
			}
		});
	}

	cancelModal(modal: any) {
		modal.dismiss();
	}


	private handleCancelResponse(results: any, orderno: any) {
		this.cancel.emit(true);
		this.reloadCustomer.emit(true);
		this.cart_updated.emit(results);

		if (results?.fee_accrual?.fees_retained) {
			const fee = Number(
				results.fee_accrual.fee_owed != null
					? results.fee_accrual.fee_owed
					: (Number(results.fee_accrual.distribution_fee || 0) + Number(results.fee_accrual.metrc_fee || 0))
			).toFixed(2);
			const on = results.fee_accrual.orderno || orderno;
			this.globalSearchService.showNotification(
				`Order #${on} cancelled. Brand owes MOOV $${fee} (dist+$5).`,
				'info',
				'bottom',
				'right'
			);
		}

		const data = {
			cancel: true,
			editing: false,
			neworder: false,
			orderno: orderno,
			user: this.user
		};

		this.omsService.sendOrderCheckUpdate({ data, roomName: this.CHAT_ROOM }, cb => {});
		this.omsService.sendOrderPickUpdate({ data, roomName: this.CHAT_ROOM }, cb => {});
		this.loadData(true, () => {
			this.cancellingOrderNo = null;
			this.cdr.detectChanges();
		});
	}


	setDelivered(orderno: any) {
		this.ordersService.setDelivered({ orderno: orderno }).subscribe(async (results: any) => {
			this.loadData()
		})
	}

	updatePick(orderno: any) {
		//needs callback to have customer only
		this.ordersService.updateOrderToPicked({ orderno: orderno }).subscribe(async (results: any) => {

			const data = {
				user: this.user
			};

			this.omsService.sendOrderCheckUpdate({ data, roomName: this.CHAT_ROOM }, cb => {});
			this.loadData()
		})
	}

	drawMap() {

		this.globalSearchService.hideSideBar();
		const coordinates = [];
		const columndata = this.orderdetails.dispatch_details;

		const home = { lat: columndata.clat, lng: columndata.clng }
		const truckpos = { lat: columndata.lastlat, lng: columndata.lastlng }
		const counter = 0;
		const trucklat = new google.maps.LatLng(truckpos);
		const lines = [trucklat];
		lines.push(home)

		const regex = /<br\s*[\/]?>/gi;
		//<br />
		const name = columndata.address.replace(regex, '\n');
		const m = new google.maps.Marker({
			position: home,
			title: name,
			optimized: true,
			animation: google.maps.Animation.DROP,
			label: {
				text: name,
				color: '#000',
				fontSize: '14px',
				fontWeight: 'bold'
			}
		}, );

		coordinates.push(m);

		const c = new google.maps.Marker({
			position: trucklat,
			title: columndata.truck_name,
			optimized: true,
			animation: google.maps.Animation.DROP,
			label: {
				text: columndata.truck_name,
				color: '#000',
				fontSize: '14px',
				fontWeight: 'bold'
			}
		});

		coordinates.push(c);

		const mapOptions = {
			zoom: 11,
			center: home,
			scrollwheel: false, //we disable de scroll over the map, it is a really annoing when you scroll through page
			styles: [{
				'featureType': 'water',
				'stylers': [{
					'saturation': 43
				}, {
					'lightness': -11
				}, {
					'hue': '#0088ff'
				}]
			}, {
				'featureType': 'road',
				'elementType': 'geometry.fill',
				'stylers': [{
					'hue': '#ff0000'
				}, {
					'saturation': -100
				}, {
					'lightness': 99
				}]
			}, {
				'featureType': 'road',
				'elementType': 'geometry.stroke',
				'stylers': [{
					'color': '#808080'
				}, {
					'lightness': 54
				}]
			}, {
				'featureType': 'landscape.man_made',
				'elementType': 'geometry.fill',
				'stylers': [{
					'color': '#ece2d9'
				}]
			}, {
				'featureType': 'poi.park',
				'elementType': 'geometry.fill',
				'stylers': [{
					'color': '#ccdca1'
				}]
			}, {
				'featureType': 'road',
				'elementType': 'labels.text.fill',
				'stylers': [{
					'color': '#767676'
				}]
			}, {
				'featureType': 'road',
				'elementType': 'labels.text.stroke',
				'stylers': [{
					'color': '#ffffff'
				}]
			}, {
				'featureType': 'poi',
				'stylers': [{
					'visibility': 'off'
				}]
			}, {
				'featureType': 'landscape.natural',
				'elementType': 'geometry.fill',
				'stylers': [{
					'visibility': 'on'
				}, {
					'color': '#b8cb93'
				}]
			}, {
				'featureType': 'poi.park',
				'stylers': [{
					'visibility': 'on'
				}]
			}, {
				'featureType': 'poi.sports_complex',
				'stylers': [{
					'visibility': 'on'
				}]
			}, {
				'featureType': 'poi.medical',
				'stylers': [{
					'visibility': 'on'
				}]
			}, {
				'featureType': 'poi.business',
				'stylers': [{
					'visibility': 'simplified'
				}]
			}]

		};

		this.map = new google.maps.Map(document.getElementById('map'), mapOptions);

		coordinates.forEach((item: any) => {
			item.setMap(this.map);
		});

		const lineSymbol = {
			path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
		};

		const pathTo = new google.maps.Polyline({
			path: lines,
			geodesic: true,
			strokeColor: '#F1575A',
			strokeOpacity: 1.0,
			strokeWeight: 2,
			icons: [{
				icon: lineSymbol,
				offset: '100%'
			}],
		});

		pathTo.setMap(this.map);
	}

	getTotalQuantity(): number {
		if (!this.podetails || !this.podetails.polines) {return 0;}
		return this.podetails.polines.reduce((total, item) => parseFloat(total) + parseFloat(item.quantityord), 0);
	}

	getTotalValue(): number {
		if (!this.podetails || !this.podetails.polines) {return 0;}
		return this.podetails.polines.reduce((total, item) => parseFloat(total) + (parseFloat(item.unitprice) * parseFloat(item.quantityord)), 0);
	}

	async copyToClipboard (text: string): Promise < void > {
		try {
			await navigator.clipboard.writeText(text);
		} catch (err) {}
	}

	back(): void {
		this.location.back()
	}

	//merge stuff
	mergeList: any[] = []; // List to hold selected orders

	mergeOrders(): void {
		if (this.mergeList.length === 0) {
			return;
		}

		// Group orders by debtorno
		const groupedOrders = this.mergeList.reduce((acc, order) => {
			if (!acc[order.debtorno]) {
				acc[order.debtorno] = [];
			}
			acc[order.debtorno].push(order.orderno);
			return acc;
		}, {} as {
			[key: string]: string[]
		});

		const payload = Object.keys(groupedOrders).map(debtorno => ({
			debtorno,
			orders: groupedOrders[debtorno]
		}));

		this.ordersService.mergeOrders(payload).subscribe((r: any) => {
			if (r.success) {
				this.mergeList = [];
				this.loadData();
			} else {
				this.globalSearchService.showNotification(r.error, 'danger', 'bottom', 'right');
			}
		});
	}

	isSelected(order: any): boolean {
		return this.mergeList.some(o => o.orderno === order.orderno);
	}

	toggleOrderSelection(event: any, order: any): void {
		if (event.checked) {
			if (!this.isSelected(order)) {
				this.mergeList.push(order);
			}
		} else {
			this.mergeList = this.mergeList.filter(o => o.orderno !== order.orderno);
		}
	}

	isAllSelected(): boolean {
		return this.openorders.length && this.mergeList.length === this.openorders.length;
	}

	isSomeSelected(): boolean {
		return this.mergeList.length > 0 && !this.isAllSelected();
	}

	selectAll(event: any): void {
		if (event.checked) {
			this.mergeList = [...this.openorders];
		} else {
			this.mergeList = [];
		}
	}

	ngOnDestroy(): void {
		this.pickPdfFetchSub?.unsubscribe();
		this.pickPdfFetchSub = null;
		this.revokePickPreviewBlob();
		this.pickSafeUrl = null;
		if (this.debounceTimeout) {
			clearTimeout(this.debounceTimeout);
		}
		if (this.searchDebounce) {
			clearTimeout(this.searchDebounce);
		}
		this.subscriptions.forEach(sub => {
			if (sub && !sub.closed) {
				sub.unsubscribe();
			}
		});
		this.subscriptions = [];
		if (this.dataSubscription && !this.dataSubscription.closed) {
			this.dataSubscription.unsubscribe();
		}
		this.batchCancel$.next();
		this.batchCancel$.complete();
		this.destroy$.next();
		this.destroy$.complete();
	}

	trackByOrderNo(index: number, order: any): any {
		return order.orderno;
	}

	getTrackingColor(shipper: string | null | undefined): string {
		return this.carrierTracking.getTrackingColor(shipper);
	}


	applicableTracking(tran: any) {
		return tran.tracking?.some(t => t.trackingnumber)
	}
	trackingIncludes(tran: any, num: string): boolean {
		if (!num || !tran?.tracking || !Array.isArray(tran.tracking)) return false
		return tran.tracking.some((t: any) => (t?.trackingnumber && String(t.trackingnumber) === String(num)))
	}
	toggleMerging(): void {
		this.isMerging = !this.isMerging;
		if (!this.isMerging) {
			this.mergeList = [];
		}
	}

	// ---- Batch pick-sheet print -------------------------------------------
	// Distinct from the "merge orders" feature above. Reveals per-row checkboxes,
	// then POSTs selected orders in chunks (JSON), shows x of y, and finally
	// assembles one merged PDF (documents/picking/batch).
	isBatchPrinting = false;
	batchList: any[] = [];
	batchBusy = false;
	batchProgress: { current: number; total: number; label: string; orderno: string; phase: 'render' | 'assemble' | 'download' | '' } =
		{ current: 0, total: 0, label: '', orderno: '', phase: '' };
	private batchCancel$ = new Subject<void>();
	private readonly batchChunkSize = 1;

	toggleBatchPrinting(): void {
		if (this.batchBusy) {
		this.batchCancel$.next();
		this.batchBusy = false;
		this.batchProgress = { current: 0, total: 0, label: '', orderno: '', phase: '' };
		}
		this.isBatchPrinting = !this.isBatchPrinting;
		if (!this.isBatchPrinting) {
			this.batchList = [];
		}
	}
	isBatchSelected(order: any): boolean {
		return this.batchList.some(o => o.orderno === order.orderno);
	}
	toggleBatchSelection(event: any, order: any): void {
		if (event.checked) {
			if (!this.isBatchSelected(order)) { this.batchList.push(order); }
		} else {
			this.batchList = this.batchList.filter(o => o.orderno !== order.orderno);
		}
	}
	isAllBatchSelected(): boolean {
		return this.openorders.length && this.batchList.length === this.openorders.length;
	}
	isSomeBatchSelected(): boolean {
		return this.batchList.length > 0 && !this.isAllBatchSelected();
	}
	selectAllBatch(event: any): void {
		this.batchList = event.checked ? [...this.openorders] : [];
	}

	get batchProgressPercent(): number {
		if (!this.batchProgress.total) { return 0; }
		return Math.round((100 * this.batchProgress.current) / this.batchProgress.total);
	}

	/** Render selected orders in chunks (JSON), then assemble and download the merged PDF. */
	async printBatch(): Promise<void> {
		if (this.batchBusy || !this.batchList.length) { return; }
		const orders = this.batchList.map(o => String(o.orderno));
		const isPOS = (this.ispos || '').includes('true') ? 'true' : 'false';
		const total = orders.length;

		this.batchBusy = true;
		this.batchProgress = { current: 0, total, label: 'Starting…', orderno: '', phase: 'render' };
		this.cdr.detectChanges();

		const finish = () => {
		this.batchBusy = false;
		this.batchProgress = { current: 0, total: 0, label: '', orderno: '', phase: '' };
		this.cdr.detectChanges();
	};

		let cancelled = false;
		const cancelSub = this.batchCancel$.subscribe(() => { cancelled = true; });

		const post = (body: { orders: string[]; isPOS: string; batch_id?: string; action: 'render' | 'assemble' }) =>
			new Promise<any>((resolve, reject) => {
				this.ordersService.batchPickSheets(body).subscribe({
					next: (res) => resolve(res),
					error: (err) => reject(err),
				});
			});

		const errText = (err: any, fallback: string): string => {
			if (!err) { return fallback; }
			if (typeof err === 'string') { return err; }
			if (err.error && typeof err.error === 'string' && err.error.length < 300) { return err.error; }
			if (err.error && typeof err.error === 'object' && (err.error.error || err.error.message)) {
				return String(err.error.error || err.error.message);
			}
			if (err.message) { return String(err.message); }
			return fallback;
		};

		/** Top-level navigation download — same pattern as pick-sheet <a href>, avoids CORS on PDF XHR. */
		const triggerDownload = (method: string, filename: string) => {
			const url = this.ordersService.buildDocumentApiUrl(method);
			const a = document.createElement('a');
			a.href = url;
			a.download = filename;
			a.rel = 'noopener';
			a.style.display = 'none';
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
		};

		try {
			let batchId = '';
			const failed: string[] = [];

			for (let i = 0; i < orders.length; i += this.batchChunkSize) {
				if (cancelled) {
					this.globalSearchService.showNotification('Batch print cancelled.', 'warning', 'bottom', 'right');
					finish();
					return;
				}

			const chunk = orders.slice(i, i + this.batchChunkSize);
			this.batchProgress = { current: i, total, label: 'Building', orderno: chunk[0], phase: 'render' };
			this.cdr.detectChanges();

				const res = await post({
					orders: chunk,
					isPOS,
					batch_id: batchId || undefined,
					action: 'render',
				});

				if (cancelled) {
					this.globalSearchService.showNotification('Batch print cancelled.', 'warning', 'bottom', 'right');
					finish();
					return;
				}

				if (!res || res.success === false) {
					this.globalSearchService.showNotification(
						(res && (res.error || res.message)) || 'Batch render failed.',
						'danger',
						'bottom',
						'right',
					);
					finish();
					return;
				}

				if (res.batch_id) {
					batchId = String(res.batch_id);
				}

				const rendered = Array.isArray(res.rendered) ? res.rendered : [];
				for (const row of rendered) {
					if (!row || !row.ok) {
						failed.push(String(row?.orderno || '?'));
					}
				}

			const processed = Math.min(i + chunk.length, total);
			this.batchProgress = { current: processed, total, label: 'Building', orderno: chunk[chunk.length - 1], phase: 'render' };
			this.cdr.detectChanges();
			}

			if (!batchId) {
				this.globalSearchService.showNotification('No pick sheets could be generated.', 'danger', 'bottom', 'right');
				finish();
				return;
			}

			if (failed.length === orders.length) {
				this.globalSearchService.showNotification(
					`No pick sheets could be generated (${failed.join(', ')}).`,
					'danger',
					'bottom',
					'right',
				);
				finish();
				return;
			}

		this.batchProgress = { current: total, total, label: 'Merging PDFs', orderno: '', phase: 'assemble' };
		this.cdr.detectChanges();

			const assembleRes = await post({
				orders,
				isPOS,
				batch_id: batchId,
				action: 'assemble',
			});

			if (cancelled) {
				this.globalSearchService.showNotification('Batch print cancelled.', 'warning', 'bottom', 'right');
				finish();
				return;
			}

			if (!assembleRes || assembleRes.success === false || !assembleRes.download) {
				this.globalSearchService.showNotification(
					(assembleRes && (assembleRes.error || assembleRes.message)) || 'Failed to assemble merged pick PDF.',
					'danger',
					'bottom',
					'right',
				);
				finish();
				return;
			}

		this.batchProgress = { current: total, total, label: 'Downloading', orderno: '', phase: 'download' };
		this.cdr.detectChanges();

			const filename = String(assembleRes.filename || `PickSheets-${moment().format('YYYY-MM-DD')}.pdf`);
			triggerDownload(String(assembleRes.download), filename);

			const okCount = orders.length - failed.length;
			const note = failed.length
				? `${okCount} of ${orders.length} pick sheet(s) downloaded (${failed.length} failed).`
				: `${okCount} pick sheet(s) downloaded.`;
			this.globalSearchService.showNotification(note, failed.length ? 'warning' : 'success', 'bottom', 'right');
			this.batchList = [];
			this.isBatchPrinting = false;
			finish();
		} catch (err) {
			if (!cancelled) {
				this.globalSearchService.showNotification(errText(err, 'Batch print failed.'), 'danger', 'bottom', 'right');
			}
			finish();
		} finally {
			cancelSub.unsubscribe();
		}
	}
}